<template>
    <div>
        <h3>記事を書く</h3>
        <div>
            <p>
                サブドメインを取得していれば、記事を追加することができます。
                記事は任意の場所に公開する設定を行うまで人目に触れることはありません。
            </p>
            <p>
                記事は活動記録や創作論、執筆作業の場について、あるいはご自身の作品の資料、
                登場人物紹介や地図、設定、年表などを作成することができます。
            </p>
            <p>
                記事だけを登録することも可能ですが、貸し本棚はあくまで小説保管サイトです。
                ブログとして利用するのには向いていません。
            </p>

            <h4>新規記事の追加</h4>
            <img src="/img/help/article/01.png" alt="新規記事" class="img-thumbnail mb-3">
            <p>
                マイページの「記事」タブから「新規記事を書く」をクリックして、新規記事画面を表示します。
                この画面はノートと同じブロックエディタを採用しています。
                但し、ノートとは見出しデザインなどが異なります。
            </p>
            <p>
                記事タイトルを入力して、本文を記述してください。
                エディタの下部に記事のサイズと最大サイズが表示されます。
                最大サイズを超えると赤表示となり、保存できなくなるのでご注意ください。
            </p>
            <p>
                記事中の本文にはいくつかのブロックレイアウト、インラインレイアウトを設定することが可能です。
            </p>
            <h5>ブロックレイアウト</h5>
            <p>
                ６段階の見出しを設定することができます。
                記事見出しはそのままアウトラインの見出しになります。
                ブロックを見出しに変えるときは、１文字以上を選択して、Tアイコンから「見出し」を選択してください。
                デフォルトではレベル２の見出しになっています。
            </p>
            <p>
                リストあるいはチェックリストを追加できます。
                リスト化したい内容があるときは、このレイアウトを推奨します。
            </p>
            <p>
                テーブルを追加することもできます。
                テーブルは3 x 2で作成され、任意に行列を増減できます。
                あまり横長なテーブルを作成すると、表示したときにレイアウト崩れが起きるのでご注意ください。
            </p>
            <p>
                テキストのアライメントを設定できます。
                基本的には左寄せになっていますが、中央寄せ、右寄せを設定することができます。
                中央寄せはレイアウトが汚れる原因になるので、多用は避けてください。
            </p>
            <p>
                ブロックを強調、引用、詳細に設定することができます。
                強調すると赤枠で囲われ、引用すると斜体に、詳細にすると文字サイズが小さくなります。
            </p>
            <h5>インラインレイアウト</h5>
            <p>
                キャレットで選択した部分に対して、インラインレイアウトを設定することができます。
            </p>
            <p>
                太字、斜体、下線を引くことができ、マーカーで強調表示することができます。
                また、文字色を変更することも可能です。
            </p>
            <p>
                選択文字列にリンクを設定することもできます。
            </p>

            <h4>記事のレーティング</h4>
            <p>
                記事にもレーティングを設定することができます。
                このレーティングは登録ユーザーに対して有効で、未登録ユーザーはすべての記事が表示されます。
            </p>

            <h4>タグ</h4>
            <p>
                記事には最大５個までのタグを設定することができます。
                同一のタグを持つ記事を関連記事として抽出することができます。
            </p>

            <h4>公開先選択</h4>
            <p>
                公開先を選択することによって、指定の場所に記事を公開することができます。
                ここで公開先を選択せずに「公開」を実行しても、記事へのリンクはどこにも表示されません。
                直接URL指定で参照することはできるので、実際の公開前の確認などで利用できます。
            </p>
            <p>
                詳細は
                <router-link to="/help/article/publish">記事を公開する</router-link>
                を参照してください。
            </p>

            <h4>保存と公開</h4>
            <p>
                記事を<b>下書き保存</b>すると、公開されない状態で下書き保存します。
            </p>
            <p>
                記事を<b>公開</b>すると、指定した公開先に記事が公開されます。
                すでに公開済みの記事の場合、<b>更新</b>となります。
            </p>
            <p>
                公開済みの記事を編集したとき、「下書き保存」すると編集内容は下書き状態で保存され、
                公開されている記事には影響しません。
                「更新」を行うことで、編集内容を公開記事に反映することができます。
            </p>
            <p>
                編集中にページを離脱しても警告されません。編集内容は常に自動保存されます。
                この自動保存は、小説やノートの自動保存とは異なります。
            </p>
            <h4>画像を貼る</h4>
            <p>
                画像を記事に貼り付ける方法は２種類あります。
                ひとつは記事に直接画像を埋め込む方法。
                もうひとつは外部の画像URLを貼り付ける方法です。
            </p>
            <h5>記事に画像を埋め込む</h5>
            <p>
                記事に直接画像をドラッグ・アンド・ドロップすることで、画像を記事に埋め込むことができます。
                この画像は記事データの一部となるので、記事の容量が増大します。
            </p>
            <p>
                この方法で埋め込んだ画像の一番上にあるものが、記事のアイキャッチ画像として選択されます。
            </p>
            <p>
                埋め込み方式では画像をページ展開するのに時間がかかるため、大量の画像埋め込みには向いていません。
            </p>
            <h5>外部の画像を貼り付ける</h5>
            <p>
                外部に置かれていて、かつ外部参照が可能な画像URLを貼り付けると、自動的に画像タグとして展開します。
                貼り付けることができる画像URLは以下のとおりです。
            </p>
            <ol>
                <li>gif/jpg/png/webpなどの画像拡張子で終わるURL。</li>
                <li>gyazo.comの画像。</li>
                <li>Google Photoで「リンクを生成」して公開した画像。</li>
            </ol>
            <p>
                Google Photoの画像は通常の方法で貼り付けることができません。
            </p>
            <ol>
                <li>Google Photoでアルバムを作成します。</li>
                <li>アルバムのオプションで「リンクの共有」をONにします。</li>
                <li>アルバムに貼り付けたい画像を追加します。</li>
                <li>追加した画像を右クリックして「画像アドレスのコピー」でURLをコピーします。</li>
                <li>コピーしたURLを記事に貼り付けます（https://lh3.googleusercontent.com/pw/...というURLです）。</li>
            </ol>
            <p>
                上記の方法で生成したURLを貼り付けると、記事にGoogle Photoの画像を貼り付けることができます。
                この方法はGoogleに推奨されている方法ではありませんので、今後この方法で画像貼り付けができるという保証はありません。
                Google Photoはアルバムで画像の整理整頓ができるので、貼り付ける画像が多い場合は便利です。
            </p>

            <h4>記事一覧</h4>
            <p>
                追加された記事は、記事タブに一覧表示されます。
                記事をクリックすると編集することができます。
            </p>
            <p>
                記事に画像が含まれる場合、最初の画像がアイキャッチ画像として自動的に使用されます。
            </p>
            <img src="/img/help/article/02.png" alt="記事一覧" class="img-thumbnail mb-3">
            <p>
                公開済みの記事は
                <i class="far fa-eye text-primary"></i>
                アイコンが表示され、
                未公開の記事は
                <i class="far fa-eye-slash text-danger"></i>
                アイコンが表示されます。
                また、公開済みの記事が編集途中の場合、
                <i class="fas fa-edit"></i>
                アイコンが表示されます。
            </p>

            <h4>記事機能のトラブル</h4>
            <p>
                記事、及びノート、お問い合わせのテキスト入力機能には、同一のブロックエディタが採用されています。
                このブロックエディタには、Chromeの一部拡張機能と競合し、<b>Backspaceでテキストブロックが消失する</b>問題が報告されています。
                テキストが消失するトラブルが発生した場合は、拡張機能の一時停止をお試しください。
            </p>

        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "記事を追加する | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>